import { useLanguage } from "contexts/LanguageContext";
import { Modifier } from "types/Employee";

export const getFullname = (modifier: Modifier) =>
  `${modifier?.firstname} ${modifier?.lastname}`;

export const translateLabel = (
  key: string,
  messages: ReturnType<typeof useLanguage>["messages"]
) => {
  const mapping: Record<string, string> = {
    fixum: messages.fixum,
    variable: messages.variable,
    singlepayment: messages.information.singlePayment,
    status: messages.statusCaption,
    degree: messages.degree,
    companyCar: messages.companyCar,
    hours: messages.weekLabel,
    teamlead: messages.responsibility,
    seniority: messages.leadLevel,
    reason: messages.comment,
    approver: messages.approvalNextApproversLabel,
  };

  return mapping[key] || key;
};
